import { match as integer } from "../../../src/params/integer.ts";
import { match as org_code } from "../../../src/params/org_code.ts";
import { match as session_code } from "../../../src/params/session_code.ts";
import { match as session_uid } from "../../../src/params/session_uid.ts";
import { match as uid } from "../../../src/params/uid.ts";
import { match as username_or_id } from "../../../src/params/username_or_id.ts";

export const matchers = { integer, org_code, session_code, session_uid, uid, username_or_id };